module.exports = __webpack_public_path__ + "media/assets/images/rw-modal-01-17fd7be8264a23fbdf4d039e05ee0c8e.jpg";